import Web3 from "web3/dist/web3.min";

console.log('If you are seeing this, checking out defido.com or @defido on twitter/instagram would be good. With love...');
console.log('This javascript is ugly, yes, but it works, so we accept it.');
export default Web3;